import axios from 'axios';
import { LlavesEndPointServicios } from "../Configuracion/Llaves/RepositorioConfig";


//punto de acceso base para todos los end point
//PRD:http://localhost:9696/SERVICIOS/ApiDemo/api 
//DEV:http://localhost:5006/api

const InstanciaAxios = axios.create();
InstanciaAxios.defaults.baseURL = LlavesEndPointServicios.UrlServicioCore;

//Interceptor para capturar el tocken y para agregarlo a todo request que se realice
InstanciaAxios.interceptors.request.use((config) => {
    const token_seguridad = window.localStorage.getItem("token_seguridad");
    if (token_seguridad != null) {
        config.headers.Authorization = 'Bearer ' + token_seguridad;
    }
    return config;
},
    error => {
        return Promise.reject(error);
    }
);

//objeto que representa las peticiones genericas que se hagan al [Api CORE] del set 
const requestGenericoCore = {
    get: (url) => InstanciaAxios.get(url),
    post: (url, body) => InstanciaAxios.post(url, body),
    put: (url, body) => InstanciaAxios.put(url, body),
    delete: (url) => InstanciaAxios.delete(url)
};

export default requestGenericoCore;